import { DialogService } from "../../../ServiceDesk/sdServices/dialog";

export class WizardHarnessController {
  // @ngInject
  constructor(private dialogService: DialogService) {}

  finishWizard() {
    this.dialogService.showContent("Finished!", "Wizard Completion Status", undefined, false);
  }
}
